export const COOKIE_CONSENT = 'cookieConsent';

export type DataLayerEvent = {
  event: string;
  [key: string]: unknown;
};

// Initialize dataLayer if it doesn't exist
if (!window.dataLayer) {
  window.dataLayer = [];
}

/** Push an event to the dataLayer*/
const push = (event: DataLayerEvent): void => {
  window.dataLayer.push(event);
};

/** Push a custom event */
const event = (
  eventName: string,
  eventCategory: string,
  eventAction: string,
  eventLabel?: string,
  eventValue?: number,
): void => {
  push({
    event: eventName,
    category: eventCategory,
    action: eventAction,
    label: eventLabel,
    value: eventValue,
  });
};

/** Clear the dataLayer */
const clear = (): void => {
  window.dataLayer = [];
};

export const dataLayer = {
  push,
  event,
  clear,
};
